import * as React from "react"

const CircleAlarmClock = ({ width = 60, height = 60, props }) => (
  <svg viewBox="0 0 40 40" width={width} height={height} fill="none" {...props}>
    <circle cx={18} cy={18} r={18} fill="#00E96E" fillOpacity={0.149} />
    <path
      stroke="#00E96E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.002}
      d="M16.294 10.652a8.44 8.44 0 1 0 3.653.104 8.442 8.442 0 0 1-.473 16.475 8.44 8.44 0 0 1-3.18-16.579Z"
      clipRule="evenodd"
    />
    <path
      stroke="#00E96E"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.884 18.942v5.151M17.883 18.942l3.67-3.615"
    />
    <path
      stroke="#00E96E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.987}
      d="m13.676 9.18.065-.928a.664.664 0 0 0-1.037-.596l-4.206 2.87a.665.665 0 0 0 .177 1.184l1.038.324M22.099 9.18l-.064-.908a.676.676 0 0 1 1.054-.605l4.17 2.847a.676.676 0 0 1-.18 1.202l-1.017.317"
    />
  </svg>
)
export default CircleAlarmClock
